import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import { ConfigProvider } from "antd";

const muiTheme = getMuiTheme({
  tabs: {
    backgroundColor: "#ffffff",
    textColor: "#000000",
    selectedTextColor: "#000000",
  },
});

ReactDOM.render(
  <BrowserRouter>
    <MuiThemeProvider muiTheme={muiTheme}>
      <ConfigProvider
        theme={{
          token: {
            Button: {
              colorPrimary: "#005299",
              borderRadius: 2,
            },
            Tabs: {
              colorPrimary: "#005299",
              cardBg: "#d3d3dfb8",
            },
          },
        }}
      >
        <App />
      </ConfigProvider>
    </MuiThemeProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
